export default "__VITE_ASSET__BTcsXVa$__"